import type { IDeliveryZone } from "../interfaces/IDeliveryZone";

function polyIsClockwise(poly: [number, number][]) {
  var sum = 0;
  for (var i = 0; i < poly.length - 1; i++) {
    var cur = poly[i],
      next = poly[i + 1];
    sum += (next[0] - cur[0]) * (next[1] + cur[1]);
  }
  return sum > 0;
}

function pointInPolygon(p: [number, number], polygon: [number, number][][]) {
  let i = 0;
  let ii = 0;
  let k = 0;
  let f = 0;
  let u1 = 0;
  let v1 = 0;
  let u2 = 0;
  let v2 = 0;
  let currentP = null;
  let nextP = null;

  const x = p[0];
  const y = p[1];

  const numContours = polygon.length;
  for (i; i < numContours; i++) {
    ii = 0;
    const contourLen = polygon[i].length - 1;
    const contour = polygon[i];

    currentP = contour[0];
    u1 = currentP[0] - x;
    v1 = currentP[1] - y;

    for (ii; ii < contourLen; ii++) {
      nextP = contour[ii + 1];

      v2 = nextP[1] - y;

      if ((v1 < 0 && v2 < 0) || (v1 > 0 && v2 > 0)) {
        currentP = nextP;
        v1 = v2;
        u1 = currentP[0] - x;
        continue;
      }

      u2 = nextP[0] - p[0];

      if (v2 > 0 && v1 <= 0) {
        f = u1 * v2 - u2 * v1;
        if (f > 0) k = k + 1;
        else if (f === 0) return 0;
      } else if (v1 > 0 && v2 <= 0) {
        f = u1 * v2 - u2 * v1;
        if (f < 0) k = k + 1;
        else if (f === 0) return 0;
      } else if (v2 === 0 && v1 < 0) {
        f = u1 * v2 - u2 * v1;
        if (f === 0) return 0;
      } else if (v1 === 0 && v2 < 0) {
        f = u1 * v2 - u2 * v1;
        if (f === 0) return 0;
      } else if (v1 === 0 && v2 === 0) {
        if (u2 <= 0 && u1 >= 0) {
          return 0;
        } else if (u1 <= 0 && u2 >= 0) {
          return 0;
        }
      }
      currentP = nextP;
      v1 = v2;
      u1 = u2;
    }
  }

  if (k % 2 === 0) return false;
  return true;
}

function arrayToPairs(array: any[]) {
  return array.reduce(function (result, value, index, array) {
    if (index % 2 === 0) result.push(array.slice(index, index + 2));
    return result;
  }, []);
}

export function getContainingDeliveryZone(
  coords: [number, number],
  deliveryZones: IDeliveryZone[]
): IDeliveryZone | null {
  for (const zone of deliveryZones) {
    const poly = arrayToPairs(zone.points);

    const first = poly[0],
      last = poly[poly.length - 1];
    if (first[0] !== last[0] && first[1] !== last[1]) poly.push(first);

    if (!polyIsClockwise(poly)) poly.reverse();
    const res = pointInPolygon(coords, [poly]);
    if (res === true || res === 0) {
      return zone;
    }
  }

  return null;
}
